export const COMMUNITY_BUILD_CATEGORIES = [
  { value: "hauling", label: "Hauling", image: "/ship-images/type_9_heavy.webp" },
  { value: "combat", label: "Combat", image: "/ship-images/federal_corvette.webp" },
  { value: "exploration", label: "Exploration", image: "/ship-images/diamondback_explorer.webp" },
  { value: "mining", label: "Mining", image: "/ship-images/python.webp" },
  { value: "anti-xeno", label: "Anti-Xeno", image: "/ship-images/alliance_chieftain.webp" },
  { value: "specialist", label: "Specialist", image: "/ship-images/beluga.webp" },
] as const;

export const COMMUNITY_BUILD_ROLES = [
  ...COMMUNITY_BUILD_CATEGORIES.map(({ value, label }) => ({ value, label })),
  { value: "trading", label: "Trading" },
  { value: "passenger", label: "Passenger" },
  { value: "rescue", label: "Rescue" },
  { value: "multipurpose", label: "Multipurpose" },
] as const;

export type CommunityBuildRole = (typeof COMMUNITY_BUILD_ROLES)[number]["value"];

export function categoryForCommunityBuildRole(value: string) {
  const categoryValue = value === "trading" ? "hauling" : ["passenger", "rescue", "multipurpose"].includes(value) ? "specialist" : value;
  return COMMUNITY_BUILD_CATEGORIES.find((category) => category.value === categoryValue) ?? null;
}

export function shipSizeLabel(shipClass: number | null | undefined): string | null {
  if (shipClass === 1) return "Small";
  if (shipClass === 2) return "Medium";
  if (shipClass === 3) return "Large";
  return null;
}

export function landingPadLabel(shipClass: number | null | undefined): string | null {
  return shipSizeLabel(shipClass);
}
